import CourseService from '../../../modules/course/courseService'
import Errors from '../../../modules/shared/error/errors'
import Message from '../../../view/shared/message'
import { push } from 'redux-first-history'
import { i18n } from '../../../i18n'

const prefix = 'COURSE_FORM'

const courseFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,

  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,

  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  doInit: (id) => async (dispatch) => {
    try {
      dispatch({
        type: courseFormActions.INIT_STARTED,
      })

      let record = {}

      const isEdit = Boolean(id)

      if (isEdit) {
        record = await CourseService.find(id)
      }

      dispatch({
        type: courseFormActions.INIT_SUCCESS,
        payload: record,
      })
    } catch (error) {
      Errors.handle(error)

      dispatch({
        type: courseFormActions.INIT_ERROR,
      })

      dispatch(push('/course'))
    }
  },

  doCreate: (values) => async (dispatch) => {
    try {
      dispatch({
        type: courseFormActions.CREATE_STARTED,
      })

      await CourseService.create(values)

      dispatch({
        type: courseFormActions.CREATE_SUCCESS,
      })

      Message.success(
        i18n('entities.course.create.success'),
      )

      dispatch(push('/course'))
    } catch (error) {
      Errors.handle(error)

      dispatch({
        type: courseFormActions.CREATE_ERROR,
      })
    }
  },

  doUpdate: (id, values) => async (dispatch, getState) => {
    try {
      dispatch({
        type: courseFormActions.UPDATE_STARTED,
      })

      await CourseService.update(id, values)

      dispatch({
        type: courseFormActions.UPDATE_SUCCESS,
      })

      Message.success(
        i18n('entities.course.update.success'),
      )

      dispatch(push('/course'))
    } catch (error) {
      Errors.handle(error)

      dispatch({
        type: courseFormActions.UPDATE_ERROR,
      })
    }
  },
}

export default courseFormActions
